<script setup>
defineProps({
  blocks: { type: Array, default: () => [] } // Array of [heading, htmlBody]; first -> <h2>, rest -> <h3>
})
</script>

<template>
  <section class="block tight">
    <div class="wrap">
      <div class="prose">
        <template v-for="(block, i) in blocks" :key="i">
          <h2 v-if="i === 0">{{ block[0] }}</h2>
          <h3 v-else>{{ block[0] }}</h3>
          <p v-html="block[1]" />
        </template>
      </div>
    </div>
  </section>
</template>
